import { IWindowService } from 'angular';
import { Toggles } from '../../../ng2/shared/constants/toggles.constant';
import { USER_ROLE_PERMISSIONS_FOR_STATES } from '../../../ng2/shared/constants/user-role-permissions-for-states.constant';

angular.module('nv.routes.main').config($stateProvider => {
  /* istanbul ignore next */
  $stateProvider.state('main.networkSettings', {
    abstract: false,
    url: '/network/settings/?grouping',
    template: `<network-settings
                  [current-user]="$resolve.currentUser"
               ></network-settings>`,
    data: {
      roles: USER_ROLE_PERMISSIONS_FOR_STATES['main.networkSettings'],
      toggles: [Toggles.TOGGLE_NETWORK_DASHBOARD],
    },
    onEnter: ($window: IWindowService) => {
      $window.document.title = 'Settings - User Permissions | Network Data Portal';
    },
    onExit: ($window: IWindowService) => {
      $window.document.title = 'Data Portal';
    },
  });
});
